/**
 * Build-time feature flags. Everything defaults to off; enable a feature by
 * setting the matching env var to "true" (e.g. in `.env.local`) and rebuilding.
 *
 * - `support`: support centre, FAQ, tickets, notification bell, "Ouvrir un ticket".
 *   The backend endpoints are always live; this only gates the UI.
 * - `staffMenu`: the grouped "Staff" header menu. When off, staff get the
 *   Admin / Manuel administrateur entries in the profile menu instead.
 */
export default {
  support: process.env.VUE_APP_FEATURE_SUPPORT === 'true',
  staffMenu: process.env.VUE_APP_FEATURE_STAFF_MENU === 'true',
}
